(function(){
  var slides=[].slice.call(document.querySelectorAll('.slide'));
  var segs=[].slice.call(document.querySelectorAll('.prog i'));
  var back=document.getElementById('back'), skip=document.getElementById('skip');
  var cur=0, story=document.body.getAttribute('data-story');
  /* Place each background so its focal box sits between the top bar and the first line of copy. */
  function place(slide){
    var img=slide.querySelector('.bg img[data-f]'); if(!img||!img.naturalWidth) return;
    var f=img.getAttribute('data-f').split(',').map(Number);
    var r=slide.getBoundingClientRect(), W=r.width, Hs=r.height;
    var first=slide.querySelector('.copy').firstElementChild;
    var band=first.getBoundingClientRect().top-r.top-10;
    if(!slide.classList.contains('compact') && band<0.47*r.height){ slide.classList.add('compact'); band=first.getBoundingClientRect().top-r.top-10; }
    if(!slide.classList.contains('tight') && band<0.40*r.height){ slide.classList.add('tight'); band=first.getBoundingClientRect().top-r.top-10; }
    var T=Math.min(84, Math.max(48, band*0.18));
    var iw=img.naturalWidth, ih=img.naturalHeight;
    var fw=(f[2]-f[0])*iw, fh=(f[3]-f[1])*ih;
    var need=Math.min(Hs, band+150);
    var sMin=Math.max(W/iw, need/ih);
    var sFit=Math.min(W/fw, (band-T)/fh);
    var fits=sFit>=sMin;
    if(!fits && !slide.classList.contains('tight')){ slide.classList.add(slide.classList.contains('compact')?'tight':'compact'); return place(slide); }
    var s=fits?Math.min(sFit, sMin*1.6):sMin;
    var dw=iw*s, dh=ih*s;
    var cx=(f[0]+f[2])/2*dw, cy=(f[1]+f[3])/2*dh;
    var x=Math.min(0, Math.max(W-dw, W/2-cx));
    var y=fits?((T+band)/2-cy):(T-f[1]*dh);
    y=Math.min(0, Math.max(need-dh, y));
    img.classList.add('placed');
    img.style.width=dw+'px'; img.style.height=dh+'px'; img.style.left=x+'px'; img.style.top=y+'px';
    img.style.transformOrigin=(cx)+'px '+(cy)+'px';
    slide.style.setProperty('--band', band+'px');
    img.setAttribute('data-box',[x+f[0]*dw, y+f[1]*dh, x+f[2]*dw, y+f[3]*dh, band, T, fits?1:0].map(function(v){return Math.round(v)}).join(','));
  }
  /* Slides with no photo (product card, offer): step down to compact, then tight, until the copy fits without scrolling. */
  function fit(slide){
    if(slide.querySelector('.bg img[data-f]')) return;
    var c=slide.querySelector('.copy'); if(!c.clientHeight) return;
    if(c.scrollHeight>c.clientHeight+1) slide.classList.add('compact');
    if(c.scrollHeight>c.clientHeight+1) slide.classList.add('tight');
  }
  function placeAll(){ slides.forEach(function(sl){ sl.classList.remove('compact','tight'); place(sl); fit(sl); }); }
  [].forEach.call(document.querySelectorAll('.bg img[data-f]'),function(img){
    if(img.complete) place(img.closest('.slide')); else img.addEventListener('load',function(){ place(img.closest('.slide')); });
  });
  window.addEventListener('resize',placeAll);
  if(document.fonts&&document.fonts.ready) document.fonts.ready.then(placeAll);
  fit(slides[0]);
  function show(n){
    n=Math.max(0,Math.min(slides.length-1,n));
    if(n===cur) return;
    slides[cur].classList.remove('on'); slides[cur].setAttribute('aria-hidden','true');
    cur=n;
    slides[cur].classList.add('on'); slides[cur].removeAttribute('aria-hidden');
    place(slides[cur]); fit(slides[cur]);
    segs.forEach(function(s,i){ s.classList.toggle('on', i<=cur); });
    back.hidden = cur===0;
    skip.hidden = cur===slides.length-1;
    try{ window.dataLayer && window.dataLayer.push({event:'apex_story_step', story:story, step:cur+1}); }catch(e){}
  }
  window.__story={show:show,place:placeAll};
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-next]'); if(t){ show(cur+1); return; }
    var rv=e.target.closest('.rev'); if(rv) rv.classList.toggle('open');
    var d=e.target.closest('[data-dot]');
    if(d){ var r=d.closest('.copy').querySelector('.revs'); var k=+d.getAttribute('data-dot'); r.scrollTo({left:(r.clientWidth+10)*k,behavior:'smooth'}); }
  });
  back.addEventListener('click',function(){ show(cur-1); });
  skip.addEventListener('click',function(){ var from=cur+1; show(slides.length-1); try{ window.dataLayer && window.dataLayer.push({event:'apex_story_skip', story:story, from_step:from}); }catch(e){} });
  document.addEventListener('keydown',function(e){
    if(e.key==='ArrowRight') show(cur+1);
    if(e.key==='ArrowLeft') show(cur-1);
  });
  [].forEach.call(document.querySelectorAll('.revs'),function(r){
    var dots=r.parentNode.querySelectorAll('.dot');
    r.addEventListener('scroll',function(){
      var k=Math.round(r.scrollLeft/(r.clientWidth+10));
      [].forEach.call(dots,function(d,i){ d.classList.toggle('on',i===k); });
    },{passive:true});
  });
  var buy=document.getElementById('buy');
  if(buy){
    try{
      var u=new URL(buy.getAttribute('data-base'), location.origin);
      var q=new URLSearchParams(window.location.search);
      q.forEach(function(v,k){ u.searchParams.set(k,v); });
      if(!u.searchParams.has('utm_content')) u.searchParams.set('utm_content','story-'+story);
      buy.href=u.toString();
    }catch(e){}
    buy.addEventListener('click',function(){ try{ window.dataLayer && window.dataLayer.push({event:'apex_story_cta', story:story}); }catch(e){} });
  }
})();
